// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uind","rootMobile":"styles_rootMobile__2H-yH"};